<app-profile-editor></app-profile-editor>

<router-outlet></router-outlet>